module.exports = "/subscriptions/assets/6016eca84aafc0f781cfea6bac7e9e9c.png";